import {BoxPlotFragment} from './fragments/box-plot-fragment';
import {CardResult, _CardResult} from './card-result';
import {Card} from './card';
import {NumericalHistogramFragment} from './fragments/numerical-histogram-fragment';
import {TestDistribution} from './../../compute/computations/univariate/test-distribution';
import {_UnivariateCard} from './univariate-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.ShapiroNormalityTestCard
 */
export interface ShapiroNormalityTestCard extends _UnivariateCard {
    confidenceLevel: number;

    // PolyJson type
    type: 'shapiro';
}

export function isShapiroNormalityTestCard(toTest: Card): toTest is ShapiroNormalityTestCard { return 'shapiro' === toTest.type; }

export namespace ShapiroNormalityTestCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.ShapiroNormalityTestCard$ShapiroNormalityTestCardResult
     */
    export interface ShapiroNormalityTestCardResult extends _CardResult {
        boxPlot: BoxPlotFragment;
        histogram: NumericalHistogramFragment;
        normalPdf: TestDistribution.ProbabilityDensityFunction;
        pvalue: number;
        statistic: number;

        // PolyJson type
        type: 'shapiro';
    }

    export function isShapiroNormalityTestCardResult(toTest: CardResult): toTest is ShapiroNormalityTestCardResult { return 'shapiro' === toTest.type; }
}